import React from 'react';
import { LoadingSpinner } from './LoadingSpinner';

interface NeutralSpinnerProps {
  className?: string;
}

export const NeutralSpinner = React.memo(function NeutralSpinner({
  className = '',
}: NeutralSpinnerProps) {
  return (
    <div className={`neutral-spinner ${className}`}>
      <LoadingSpinner size="lg" />

      <style>{`
        .neutral-spinner {
          width: 100%;
          min-height: 100vh;
          min-height: 100dvh;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: var(--verify-screen-bg);
          color: var(--verify-text-primary);
        }
      `}</style>
    </div>
  );
});
